import { CollectionForm } from "@/api/types";

export type ScreenId =
  | "welcome"
  | "textResponse"
  | "videoResponse"
  | "thankYou"
  | "customerForm";

export interface CollectionFormScreenProps {
  data: CollectionForm;
  onChangeStep: (ScreenId: ScreenId) => void;
}

export enum PaddingTypes {
  COMPACT = "compact",
  NORMAL = "normal",
  RELAXED = "relaxed",
  SPACIOUS = "spacious",
}

export enum SpacingTypes {
  TIGHT = "tight",
  NORMAL = "normal",
  RELAXED = "relaxed",
}
